import { DEVICESOS, DEVICES } from '@app/shared/config/device';

export const DeepLink = {
  helpCenter: {
    ios: 'pedidosya://onlinehelp',
    android: 'pedidosya://onlinehelp',
    web: '/customer-service',
  },
  home: {
    ios: 'pedidosya://home',
    android: 'pedidosya://home',
    web: '/',
  },
};

export const ACTIONS = {
  HELP_CENTER: 'helpCenter',
  HOME: 'home',
};

/**
 * generateDeepLink
 *
 * @description Function for generate deeplink based on os param
 * @param {string} action - Action to generate deep link
 * @param {string} os - OS of device (Ios | AndroidOS)
 * @param {Object} params - Any param to replace in final deeplink
 * @returns {string}
 */
export const generateDeepLink = (action, os, params) => {
  switch (os) {
    case DEVICESOS.ANDROID:
      return replaceAll(DeepLink[action].android, params);
    case DEVICESOS.IOS:
      return replaceAll(DeepLink[action].ios, params);
    case DEVICESOS.WEB:
      return replaceAll(DeepLink[action].web, params);
    default:
      return '';
  }

  function replaceAll(str, params) {
    let finalStr = str;
    for (const [key, value] of Object.entries(params)) {
      finalStr = finalStr.replace(`{${key}}`, value);
    }
    return finalStr;
  }
};

/**
 * generateLink
 *
 * @description Function for genereate link or deeplink in base to platform
 * @param {string} device - Name of device
 * @param {string} deviceOS - Operative System of device
 * @param {Object} params - Object with parameters to build final urls
 */
export const generateLink = (device, deviceOS, action, params) => {
  if (DEVICES.MOBILE === device || DEVICES.WEBVIEW === device) {
    return generateDeepLink(action, deviceOS, params);
  }
  return generateDeepLink(action, DEVICESOS.WEB, params);
};
